<template>
  <button
    :class="[buttonClass, { 'disabled-button': isDisabled }]"
    :style="customStyles"
    @click="handleClick"
    :disabled="isDisabled"
    :type="type"
  >
    <i
      v-if="this.styleType === 'greenCheckButton'"
      class="fas fa-check-circle green-check"
    ></i>
    <i
      v-else-if="this.styleType === 'back'"
      class="fas fa-arrow-left back-arrow"
    ></i>
    <i
      v-else-if="this.styleType === 'editIcon'"
      class="fas fa-edit icon-only black"
    ></i>
    <i
      v-else-if="this.styleType === 'addIcon'"
      class="fas fa-plus icon-only"
    ></i>
    <i
      v-else-if="this.styleType === 'profileIcon'"
      class="fas fa-user icon-only black"
    ></i>
    <i
      v-else-if="this.styleType === 'settingsIcon'"
      class="fas fa-cog icon-only black"
    ></i>
    <i
      v-else-if="this.styleType === 'greenCheckIcon'"
      class="fas fa-check-circle icon-only green"
    ></i>
    <i
      v-else-if="this.styleType === 'redXIcon'"
      class="fas fa-times-circle icon-only red"
    ></i>
    <i
      v-else-if="this.styleType === 'redTrashIcon'"
      class="fas fa-trash icon-only red"
    ></i>
    <i
      v-else-if="this.styleType === 'orangeClockIcon'"
      class="fas fa-clock icon-only orange"
    ></i>
    <i v-else-if="this.styleType === 'clockIn'" class="fas fa-clock"></i>
    <i
      v-else-if="this.styleType === 'clockOut'"
      class="fas fa-clock clockOutIcon"
    ></i>
    <i v-else-if="icon" :class="[icon, { 'icon-only': !label }]"></i>

    <span v-if="styleType === 'back'">Back</span>
    <span v-else-if="label && icon" style="margin-left: 8px">{{ label }}</span>
    <span v-else-if="label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "button",
    },
    styleType: {
      type: String,
      default: "default",
    },
    label: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    customStyles: {
      type: Object,
      default: () => ({}),
    },
    onClick: {
      type: Function,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modalButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonClass() {
      return {
        "aiv-button": true,
        "white-button": ["greenCheckButton", "white"].includes(this.styleType),
        "grey-button": ["grey", "back", "clockIn", "clockOut"].includes(
          this.styleType,
        ),
        "green-button": ["submit", "green"].includes(this.styleType),
        "red-button": this.styleType === "red",
        "blue-button": this.styleType === "blue",
        "coral-button": this.styleType === "coral",
        "icon-only-button":
          (this.icon && !this.label) ||
          [
            "editIcon",
            "addIcon",
            "profileIcon",
            "settingsIcon",
            "greenCheckIcon",
            "redXIcon",
            "redTrashIcon",
            "orangeClockIcon",
          ].includes(this.styleType),
        "modal-button": this.modalButton,
      };
    },
    isDisabled() {
      return this.disabled;
    },
  },
  methods: {
    handleClick(event) {
      if (!this.isDisabled) {
        if (this.styleType === "back") {
          this.$router.back();
        } else {
          this.$emit("click", event);
        }
      }
    },
  },
};
</script>

<style>
.aiv-button {
  font-size: 14px;
  border-radius: 4px;
  padding: 3px 16px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #bdbdbd;
  background-color: #656565;
  color: #c4c4c4;
}

.aiv-button:not(.disabled-button):hover {
  background-color: #8a8a8a;
}

.aiv-button i {
  margin-right: 8px;
}

.icon-only-button {
  background-color: transparent;
  border: none;
  padding: 0;
}

.icon-only-button:not(.disabled-button):hover {
  background-color: transparent;
}

.icon-only {
  margin-right: 0;
}

.black {
  color: black;
}

.green {
  color: green;
}

.red {
  color: red;
}

.orange {
  color: orange;
}

/*noinspection CssUnusedSymbol */
.white-button {
  background-color: white;
  color: black;
}

.white-button:not(.disabled-button):hover {
  background-color: #f5f5f5;
}

.grey-button {
  background-color: #909090;
  border-color: #909090;
}

.grey-button:not(.disabled-button):hover {
  background-color: #787878;
  border-color: #787878;
}

.green-check {
  color: green;
  margin-right: 8px;
  width: 14px;
}

.back-arrow {
  margin-right: 5px;
}

.clockOutIcon {
  transform: rotate(180deg);
}

.green-button {
  background-color: green;
  border-color: green;
}

.green-button:not(.disabled-button):hover {
  background-color: #2e8b57;
  border-color: #2e8b57;
}

.red-button {
  background-color: red;
  border-color: red;
}

.red-button:not(.disabled-button):hover {
  background-color: #e60000;
  border-color: #e60000;
}

.blue-button {
  background-color: #3171e2;
  border-color: #3171e2;
}

.blue-button:not(.disabled-button):hover {
  background-color: #265bb0;
  border-color: #265bb0;
}

.coral-button {
  background-color: lightcoral;
  border-color: lightcoral;
}

.coral-button:not(.disabled-button):hover {
  background-color: #d64545;
  border-color: #d64545;
}

.disabled-button {
  cursor: default;
}

.disabled-button i {
  cursor: default;
}

.disabled-button:hover {
  cursor: default;
}

.modal-button {
  width: 100%;
  height: 44px;
  font-size: 22px;
}
</style>
